/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { createSlice } from '@reduxjs/toolkit';
import { MEDIA_LIBRARY_VIEWS } from '../../constants/main';

const initialState = {

  mediaView: MEDIA_LIBRARY_VIEWS.GRID

};

const mediaFilesSlice = createSlice({
  name: 'mediaFiles',
  initialState,
  reducers: {
    mediaFilesView: (state, action) => ({
      ...state,
      mediaView: action.payload
    })
  }
});

export const mediaFilesActions = mediaFilesSlice.actions;

export default mediaFilesSlice.reducer;
